import styled, { css } from 'styled-components';
import { InputField, InputPlaceholder } from '../InputField/InputField.styles';

export const TextAreaField = (disabled?: boolean) => css`
  ${InputField(disabled)}
  max-height: 350px;

  height: 100%;
  resize: none;

  &:-webkit-autofill,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    background-color: rgb(255 255 255);
    border-color: rgb(0 0 0);
    caret-color: rgb(0 0 0);
    color: rgb(0 0 0);
  }

  &:invalid {
    background-color: rgb(127 127 127);
    pointer-events: none;
    color: rgb(0 0 0);
  }
`;

export const FieldTextArea = styled.textarea(
  ({ disabled }) => css`
    ${TextAreaField(disabled)}

    ::placeholder {
      ${InputPlaceholder()}
    }
  `
);

type TextAreaCounterAttributes = {
  $error?: boolean;
};

export const TextAreaCounter = styled.small<TextAreaCounterAttributes>(
  ({ $error }) => css`
    line-height: 0.875rem;
    font-size: 0.875rem;

    position: absolute;
    color: rgb(0 0 0);
    display: block;

    left: auto;
    bottom: 0;
    right: 0;

    ${!$error &&
    css`
      margin-top: 0.4rem;
      position: relative;
      text-align: right;
    `}
  `
);
